import "bootstrap/dist/css/bootstrap.min.css";
import { ConnectedRouter } from "connected-react-router";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { Route } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import "./index.scss";
import { history, persistor, store } from "./redux/store";
import LocaleWrapper from "./LocaleWrapper";
import ServerStatusComponent from "./hooks/useServerStatus/useServerStatus.hook";
import { ConnectionIssuePage } from "./ui/screen/ConnectionIssue";
import { CheckingConnection } from "./ui/screen/CheckingConnection";

const rawMain =
  process.env.REACT_APP_MAIN_URL ||
  (process.env.NODE_ENV === "development"
    ? "https://api.dev.wembii.com/main/api"
    : "");
const serverStatusUrl = `${String(rawMain).replace(/\/$/, "")}/status`;
const skipServerStatusGate =
  process.env.REACT_APP_SKIP_SERVER_STATUS_CHECK === "true";

ReactDOM.render(
  <>
    <Provider store={store}>
      {skipServerStatusGate ? (
        <ConnectedRouter history={history}>
          <PersistGate loading={null} persistor={persistor}>
            <LocaleWrapper>
              <Route path="/" component={App} />
            </LocaleWrapper>
          </PersistGate>
        </ConnectedRouter>
      ) : (
        <LocaleWrapper>
          <ServerStatusComponent
            url={serverStatusUrl}
            renderLoading={<CheckingConnection />}
            renderOffline={<ConnectionIssuePage />}
            renderOnline={
              <ConnectedRouter history={history}>
                <PersistGate loading={null} persistor={persistor}>
                  <Route path="/" component={App} />
                </PersistGate>
              </ConnectedRouter>
            }
          />
        </LocaleWrapper>
      )}
    </Provider>
  </>,
  document.getElementById("root")
);
